/*! @azure/msal-browser v2.14.2 2021-05-12 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.14.2";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
